export const actionDescriptions = {
    page: {
        load: 'Seitenaufruf',
    },
    contact: {
        ulmo: {
            click: 'Kontakt: Klick auf Anfrage',
        },
        ibe: {
            load: 'Kontakt: Buchungssystem laden',
        },
        reservix: {
            click: 'Kontakt: Klick auf Reservix',
        },
        ticket: {
            click: 'Kontakt: Klick auf Tickets',
        },
    },
    user: {
        click: {
            consent: {
                accept: 'Cookie-Banner: Akzeptiert',
                deny: 'Cookie-Banner: Abgelehnt',
                settings: 'Cookie-Banner: Einstellungen',
            },
            affiliate: {
                booking_com: 'Affiliate: booking_com',
                bestfewo: 'Affiliate: bestfewo',
            },
            travel_data: {
                set: 'Reisedaten: setzen',
                reset: 'Reisedaten: zurücksetzen',
            },
            nav: {
                entdecken: 'TopNav: Entdecken',
                unterkuenfte: 'TopNav: Unterkünfte',
                angebote: 'TopNav: Angebote',
                urlaubsideen: 'TopNav: Urlaubsideen',
                home: 'TopNav: Home',
                termine: 'TopNav: Termine',
                corona: 'TopNav: Corona',
                wetter: 'TopNav: Wetter',
                service: 'TopNav: Service',
            },
            abl: {
                suchbox: 'ABL: Suchbox',
                object: 'ABL: Klick (zur Detailseite)',
                pagination: 'ABL: Umblättern',
                availability: 'ABL: Verfügbarkeit',
                map: {
                    toggle: 'ABL-Karte: Ein/Ausblenden',
                    popup: 'ABL-Karte: Marker-Klick / Infowindow öffnen',
                    search: 'ABL-Karte: Suche',
                    reset: 'ABL-Karte: Zurücksetzen',
                    zoom_out: 'ABL-Karte: Rauszoomen',
                },
                filter: 'ABL: filtern',
            },
            urlaubsideen: {
                object: 'Urlaubsideen: Klick (zur Urlaubsidee)',
            },
            topic_top_abl: {
                object: 'Urlaubsideen-Top: Klick (zur Detailseite)',
                read_more: 'Urlaubsideen-Top: Weiterlesen',
            },
            detail: {
                region_link: 'Detailseite: Klick (zu ABL der Region)',
                other: {
                    object: 'Detailseite: Klick (anderes Objekt)',
                },
                offer: {
                    object: 'Detailseite: Klick (zum Angebot)',
                    navigate: 'Detailseite: Angebote navigieren',
                },
                sidebar: {
                    suchbox: 'Detailseite-Sidebar: suchbox',
                    phone_show: 'Detailseite-Sidebar: Telefon anzeigen',
                    phone_call: 'Detailseite-Sidebar: Telefon-Link ("Anruf")',
                    homepage: 'Detailseite-Sidebar: Klick (zur Homepage)',
                    map: 'Detailseite-Sidebar: Scroll-Link zur Karte',
                    to_suchbox: 'Detailseite-Sidebar: Scroll-Link zur Suchbox',
                    feedback: 'Detailseite-Sidebar: Feedback',
                    // region_link: 'Detailseite: sidebar.region_link', // => Detailseite: region_link
                },
                content: {
                    suchbox: 'Detailseite: Suchbox (im Content)',
                },
            },
            home: {
                object: 'Startseite: Klick zur Detailseite',
                category: 'Startseite: Klick zur ABL',
                suchbox: 'Startseite: Suchbox',
                read_more: 'Startseite-Text: mehr lesen',
                read_less: 'Startseite-Text: weniger lesen',
                teaser_intro: 'Startseite: teaser_intro',
                teaser_intro_xl: 'Startseite: teaser_intro_xl',
                teaser_offer_xl: 'Startseite: teaser_offer_xl',
                teaser_offer_category: 'Startseite: teaser_offer_category',
                //normales carousel
                slider: {
                    navigate: 'Startseite-Slider: navigieren',
                    // item: 'Startseite: slider.item', //todo -> slider offers "Full-Slider-Teaser"
                },
                regions: {
                    item: 'Startseite: regions.item'
                },
                // mini_tile: {
                // item: 'Startseite: mini_tile.item' // ersetzt durch 'Startseite: category'
                // },
                //multi slider mit bildunterschrift
                // tile_slider: {
                //     // navigate: 'Startseite: tile_slider.navigate',
                //     // object: 'Startseite: tile_slider.object'
                // },
                //multi slider mit overlay text
                // tile_slider_alt: {
                //     // navigate: 'Startseite: tile_slider_alt.navigate',
                //     // item: 'Startseite: tile_slider_alt.item'
                // },
                accommodation_item_slider: {
                    navigate: 'Startseite-Slider (Unterkünftsobjekte): navigieren',
                    // object: 'Startseite: accommodation_item_slider.object'
                },
                accommodation_category_slider: {
                    navigate: 'Startseite-Slider (Unterkünftskategorien): navigieren',
                },
                discover_item_slider: {
                    navigate: 'Startseite-Slider (Entdecken-Objekte): navigieren',
                    // object: 'Startseite: discover_item_slider.object'
                },
                discover_category_slider: {
                    navigate: 'Startseite-Slider (Entdecken-Kategorien): navigieren',
                },
                newsletter: 'Startseite: newsletter'
            },
            service: {
                feedback: {
                    open_form: 'Service: Feedback-Formular öffnen'
                },
                acquisition: {
                    open_form: 'Service: Interessenten-Formular öffnen',
                },
                sidebar: {
                    action: 'Service: Reiseversicherung'
                },
                corona: {
                    suchbox: 'Service: Corona-Suchbox',
                }
            },
            travel: {
                charging_stations_map_link: 'Anreise: Karte der Ladestationen',
                car_rental: 'Anreise: Mietwagenpreisvergleich',
                geo: 'Anreise: Geo-Link',
                gmaps: 'Anreise: Google Maps Link',
                applemaps: 'Anreise: Apple maps Link',
                osm: 'Anreise: OpenStreetMap Link',
            },
        }
    }
}

function propertiesToObj(obj) {
    const isObject = val =>
        typeof val === 'object' && !Array.isArray(val);

    const addDelimiter = (a, b) =>
        a ? `${a}.${b}` : b;

    const list = {};

    const paths = (obj = {}, head = '') => {
        return Object.entries(obj)
            .forEach(([key, value]) => {
                let fullPath = addDelimiter(head, key)

                isObject(value) ?
                    paths(value, fullPath)
                    : list[fullPath] = value;
            });
    }
    paths(obj);
    return list;
}

const clickTermDescriptionList = propertiesToObj(actionDescriptions);
const humanizeAction = (action, order) => {
    const description = clickTermDescriptionList[action];
    if (!description) {
        return action;
    }
    let elements = [action, description];
    elements = order ? elements : elements.reverse()
    return elements[0]
    // return `${elements[0]} [${elements[1]}]`
}

export {clickTermDescriptionList, humanizeAction}
